(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7800],{

/***/ 43008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/depop-packaging-guide/index.tsx








function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-08-13",
      tag: "Depop",
      title: "Stay on Top of Orders With the Depop Packaging Guide",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As with any sale, it is important to take the time to properly package your items before sending them to your buyer. Providing thoughtful packaging gives you the chance to interact with your customer and makes your store stand out. So consider this your opportunity to showcase your shop's unique selling proposition to customers, whether you're just getting started or developing a Depop brand."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It pays to ensure your packaging protects your goods and guarantees it gets to their destination in one piece."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Importance of packaging"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Packaging is important because its main objective is to safeguard its contents from any harm that might occur during handling, storage, and transportation. Throughout the whole logistical chain, from the manufacturer to the final user, packaging keeps the goods in perfect condition. It shields the item from humidity, light, heat, and other outside elements to ensure that it arrives at its destination (your buyer) in good condition, just as you've sent it out."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Different packaging materials to use"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When it comes to the packaging, you can take comfort in the fact that there are many alternatives available, whether you need to package large shoes for your Depop shop or wrap a piece of jewelry in a small Depop packet. Here are some different packaging materials that you can use to securely package your items:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You can choose to use new or recycled cardboard boxes, especially if you're thinking about how to pack shoes, as boxes are dependable and aid in reducing the amount of plastic in use."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Aside from buying mailers, a good alternative on Depop is to go through their collection of EcoEnclose recycled paper mailers as more paper mailers than plastic mailers are recycled."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tissue paper is often used if your item needs something to protect it during transit. For a nifty Depop packaging idea, keep the used tissue paper from birthday and special occasion gifts and use it to pack your goods to give them some color and variety."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It's a good idea to use paper tape that is recyclable or biodegradable if you can because plastic tape makes it nearly impossible to recycle or compost eco-friendly packaging."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How sellers can reuse and its benefits"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You don't always have to buy packaging every time. Many sellers are now getting into the eco-friendly habit of reusing packaging. Contrary to popular belief, reusing things and being environmentally conscious doesn't have to be difficult. With a little extra work from you, reducing the environmental effect of your shop can benefit your customers in some adorable and innovative ways."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Try to save the packing from deliveries, or request that loved ones save their packaging so you can reuse it. When choosing what packaging to use, keep the following reuse advice in the back of your mind:", /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "You could reship things using shipping boxes and mailers if they were damaged in transit. Try using the boxes you already have for other purposes; you probably have some lying around. Make sure to take off any labels or consider modifying the package."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Pay attention to the materials you recycle. Sending an item out in a bag from the grocery store won't give your consumer the finest experience possible and could result in shipping damage. Always remember that functionality should still be the primary objective."
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "One of the primary benefits of reusing packaging is that it's more forgiving on the environment and lowers your costs. Being a seller requires a lot of creativity, resourcefulness, and consideration for everyday operations, and you must go with what works best for you and your business. You can opt not to reuse packaging, or you can consider combining recycled materials with new eco-friendly packaging."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to impress buyers when they receive the item"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you're looking to make a great first impression on your buyers when they receive their orders, here are things that you can do to make them feel appreciated:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Good Packaging"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Every buyer wants good value for their money, so it is only right for them to expect the item they bought in good condition as it is the seller's responsibility. So be sure that the packaging materials you use are sturdy and can hold up well to protect your item in transportation. Don't be afraid to experiment with your packaging now and again to find cost-effective alternatives that don't sacrifice functionality."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Send thank-you notes"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Never undervalue the impact of being personally involved. Customer's always want to feel valued for their patronage, so by giving your customer a handwritten note with their purchase, you make them feel unique and give them another reason to shop with you in the future."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Buyer discounts and promos"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Customers will always find discounts to be particularly alluring, so strategically, it is a great move to use them to attract new and returning customers. Discounting goods and services, especially those in high demand, is an excellent approach to draw attention, encourage repeat purchases, and build customer loyalty."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Be neat and orderly"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Always present your item neatly and accurately write the address to lessen the likelihood that it will be misplaced and give your store a more upscale, recognizable appearance."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Include a surprise"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Customers enjoy being surprised, whether with a small bag of candy or a complimentary sticker. You can buy gifts in bulk to save money if you plan to sell many things in the coming months. Some of the most powerful businesses on Depop have grown as a result of including a tiny candy pack with each order."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Ship it right now"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Your customer will be delighted when their product is delivered fast, and they will be much more likely to give you a five-star rating, purchase again, or even share their online purchase."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Guidelines for Shipping items"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Once the sale is finalized, it's time to send it to the buyer. Be sure to use these suggestions to make shipping simple for you and your customer and get positive feedback for your efforts!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "1. Utilize tracked shipping"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When feasible, send with tracking. The seller protection offered by Depop or PayPal does not apply to untracked packages. Add insurance and get a signature when purchasing expensive products. By doing this, you give customers confidence and help your store build trust."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "2. Know your options"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "There are many alternatives available when it comes to shipping, but as a seller, you should be diligent in using a dependable service. There are usually multiple alternatives for shipping: do it yourself, use the post office where you live, or use a third-party service."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Alternatively, you can utilize Ship with Depop DropOff, which allows you to ship using MyHermes through the app and drop your package off at one of their drop-off locations. And the last option is Ship with Depop Courier Collect, which will have MyHermes pick up your package from your address."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For larger parcels, Parcel2Go and Parcel Force are the best options in the UK. The national postal service in the UK is called Royal Mail, and in the US, it is called USPS. For US sellers, Ship with Depop is also available. These mailing labels are for first-class mail in XS, S, and M sizes."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "With L and XL labels, insurance coverage is provided for items worth up to $100. UPS is a reliable choice for shipping internationally, but sellers in the US should also research \"flat rate\" delivery options as this can reduce your delivery costs and prevent the buyer from incurring additional costs."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For those in Australia, Australia Post is the country's primary mail delivery service. It is a courier service known for its practical delivery and parcel collection at home that provides customers with options that can make them feel more in control of their purchase."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When picking a courier, here are some things to take into account:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Location: Do they cater to domestic or international customers?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Convenience: A few couriers will pick up packages from your location"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Labels: How straightforward is it to print shipping labels?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Customs: Always review the guidelines for importing goods into various nations. Unpaid taxes will cause some packages to be detained. You can avoid these taxes by labeling parcels as \"gifts\" instead of \"merchandise\" when mailing from the US, as it is against the law and may result in a punishment."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to stay on top of your operations with just one dashboard?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It's always a day-to-day challenge to stay on top of orders, especially when you get a lot at once. Considering that shipping out orders is not all you have to do as a seller to keep your business running, it is a must to ensure that you are effective and efficient in your operations."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "One way pro sellers can be effective with their business management and make time for important things is by letting automation take care of their daily tasks using OneShop."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This helpful tool allows you to access many features that automate marketplace activities. You can also order shipping supplies for your business, schedule package pickups, print your shipping labels directly from the app, keep track of your seller goals and rankings, and more!"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["It also conveniently cross-list items for you across different marketplaces like Poshmark, Mercari, Depop, Tradesy, eBay, and more marketplaces soon. These and more features await you, so try it now by", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "signing up"
        }), " to set up your account in less than three minutes and enjoy a ", /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "Constants.Marketing.TrialDuration"
        }), "-day free trial!"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/depop-packaging-guide.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Stay on Top of Orders With the Depop Packaging Guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Keep ahead of your orders and impress your buyers by mastering the art of packaging your items like a PRO with this Depop packaging guide to find out everything you need to know and more!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/depop-packaging-guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/depop-packaging-guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Stay on Top of Orders With the Depop Packaging Guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Keep ahead of your orders and impress your buyers by mastering the art of packaging your items like a PRO with this Depop packaging guide to find out everything you need to know and more!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-08-13T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-08-13T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Depop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 12314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/depop-packaging-guide",
      function () {
        return __webpack_require__(43008);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(12314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);